import React, { useContext } from "react";
import { useEffect, useState, useCallback } from "react";
import { MapContainer, TileLayer, LayersControl,  useMapEvents, Marker, Popup } from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-cluster";
import { AxiosContext } from "../../AxiosContext";

import "leaflet/dist/leaflet.css";

import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";


import L from "leaflet";
import { CustomClusterIcon } from "../../elements/maps/CustomClusterIcon";

const { BaseLayer } = LayersControl;

// Fix Leaflet marker icon paths
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.3/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.3/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.3/dist/images/marker-shadow.png",
});

type Property = {
  _id: string;
  title: string;
  location: { coordinates: [number, number] }; // [lng, lat]
  price: string;
};

export const PropertiesMap = () => {
  const { publicAxios } = useContext(AxiosContext);

  const [filters, setFilters] = useState({ minPrice: "100000", maxPrice: "100000000" });
  const [bounds, setBounds] = useState<number[] | null>(null);
  const [properties, setProperties] = useState<Property[]>([]);
  const [loading, setLoading] = useState(false);

  // const [map, setMap] = useState<any>(null);

  console.log(loading, setFilters);

  // --- Fetch function ---
  const fetchProperties = useCallback(async () => {
    if (!bounds) return;
    setLoading(true);

    const query = new URLSearchParams({
      ...filters,
      bounds: bounds.join(","),
    });

    const res = await publicAxios.get(`/v1/map?${query}`);
    console.log(res.data);
    // groud data heere
    // TBD - filter or group first
    const toMap = !Array.isArray(res.data) ? [] : res.data.map((p: any) => {
      return {
        _id: p._id,
        title: p.development ? `${p.development} ${p.interior}` : `${p.street} ${p.exterior}`,
        location: p.location,
        price: p.sale.price,
      }
    });

    // const res = await fetch(`/api/properties?${query}`);
    setProperties(toMap);
    setLoading(false);
  }, [filters, bounds]);

  // --- Trigger fetch whenever bounds or filters change (debounced) ---
  useEffect(() => {
    if (!bounds) return;
    console.log('set first fetch...');
    const timeout = setTimeout(fetchProperties, 400); // debounce
    return () => { console.log('clear timeout'); clearTimeout(timeout);}
  }, [fetchProperties, bounds]);

  // --- Track map bounds ---
  function MapBoundsTracker() {
    const map = useMapEvents({
      moveend: () => {
        console.log('loaded, settings bounds');
        const b = map.getBounds();
        setBounds([b.getNorth(), b.getWest(), b.getSouth(), b.getEast()]);
      },
    });
    useEffect(() => {
      if (!bounds) {
      const b = map.getBounds();
      setBounds([b.getNorth(), b.getWest(), b.getSouth(), b.getEast()]);
      }
    }, [map, bounds]);
    return null;
  }

  return (
    <div className="encasa-map-wrapper" style={{ display: "flex", height: "600px" }}>
      {/* Sidebar filters */}
      {/* <div style={{ width: "250px", padding: "1rem", borderRight: "1px solid #ccc" }}>
        <h3>Filters</h3>
        <label>
          Min Price:
          <input
            type="number"
            value={filters.minPrice}
            onChange={(e) => setFilters({ ...filters, minPrice: e.target.value })}
          />
        </label>
        <br />
        <label>
          Max Price:
          <input
            type="number"
            value={filters.maxPrice}
            onChange={(e) => setFilters({ ...filters, maxPrice: e.target.value })}
          />
        </label>
        {loading && <p>Loading...</p>}
      </div> */}
      {/* Sidebar */}
      <div className={`map-sidebar`}>
        {
          <div className="sidebar-content">
            <h3>Filters</h3>
            <label>
              Price range:
              <input type="text" placeholder="e.g. 1000 - 5000" />
            </label>
            <label>
              Bedrooms:
              <select>
                <option>Any</option>
                <option>1+</option>
                <option>2+</option>
                <option>3+</option>
              </select>
            </label>
            <button className="btn-primary">Apply</button>
          </div>
        }
      </div>

      {/* Map */}
      {/* <div className="encasa-map"> */}
        <MapContainer
          center={[19.43145883973556, -99.13194980120416]} // Default to CDMX { lat: 19.43145883973556, lng: -99.13194980120416 };
          zoom={12}
          style={{ flex: 1 }}
          // ref={setMap}
        >
          <LayersControl position="topright">
            <BaseLayer checked name="Carto Light">
              <TileLayer
                url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/">CARTO</a>'
                subdomains={["a", "b", "c", "d"]}
              />
            </BaseLayer>

            <BaseLayer name="Carto Dark">
              <TileLayer
                url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/">CARTO</a>'
                subdomains={["a", "b", "c", "d"]}
              />
            </BaseLayer>

            {/* <BaseLayer name="Stamen Toner Lite">
              <TileLayer
                url="https://stamen-tiles.a.ssl.fastly.net/toner-lite/{z}/{x}/{y}{r}.png"
                attribution='Map tiles by <a href="http://stamen.com">Stamen Design</a>, <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                subdomains="abcd"
              />
            </BaseLayer> */}

            <BaseLayer name="OpenStreetMap">
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution="&copy; OpenStreetMap contributors"
              />
            </BaseLayer>
          </LayersControl>
          {/* <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution="© OpenStreetMap contributors"
          /> */}
          <MapBoundsTracker />

          <MarkerClusterGroup
          chunkedLoading
          showCoverageOnHover={false}
          iconCreateFunction={(cluster: any) => CustomClusterIcon({cluster, iconType: "priceBadge"})}
          // iconCreateFunction={(cluster: any) => {
          //   const count = cluster.getChildCount();
        
          //   let size = "small";
          //   if (count > 50) size = "large";
          //   else if (count > 6) size = "medium";
        
          //   return L.divIcon({
          //     html: `<div class="cluster-marker ${size}">${count}</div>`,
          //     className: "custom-cluster-icon",
          //     iconSize: L.point(40, 40, true),
          //   });
          // }}
          >
            {properties.map((p) => (
              <Marker
                key={p._id}
                // @ts-ignore because React-Leaflet types don’t include arbitrary props
                options={{ price: p.price }}
                position={[p.location.coordinates[1], p.location.coordinates[0]]} // [lat, lng]
              >
                <Popup>
                  {/* <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                    <b>{list.length} Properties</b>
                    <ul style={{ padding: 0, listStyle: "none" }}>
                      {list.map((p) => (
                        <li key={p._id} style={{ marginBottom: "8px" }}>
                          <b>{p.title}</b><br />
                          Price: ${p.price}
                        </li>
                      ))}
                    </ul>
                  </div> */}
                  <div className="">
                    <b>{p.title}</b>
                    <span>{p.price}</span>
                  </div>
                </Popup>
              </Marker>
            ))}
          </MarkerClusterGroup>
        </MapContainer>
      {/* </div> */}
    </div>
  );
}
